import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        setUser(data.user);
        // Clean hash
        window.history.replaceState({}, "", window.location.pathname);
        const target = data.user.role === "writer" || data.user.role === "admin" ? "/dashboard/writer" : "/dashboard/buyer";
        navigate(target, { replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#070707] text-white">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-[#FF6B00] border-t-transparent animate-spin" />
        <div className="text-white/60 text-sm">Signing you in…</div>
      </div>
    </div>
  );
}
